import PropTypes from 'prop-types';
import React from 'react';

import { Cross } from '@mos-cat/icon';
import MosCatTextField from '@mos-cat/text-field';

import './TextField.pcss';

const TextField = props => {
  const { clear, disabled } = props;

  return (
    <MosCatTextField
      {...props}
      clear={clear ? 'true' : 'false'}
      suffix={
        clear && !disabled ? (
          <Cross className="CrossIcon" onClick={clear} />
        ) : null
      }
    />
  );
};

TextField.propTypes = {
  clear: PropTypes.func,
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func
};

export default TextField;
